var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1336 9.96755C12.3293 9.02877 13.1001 7.56577 13.1001 5.92592C13.1001 3.1009 10.8134 0.8 8.00004 0.8C5.18672 0.8 2.90001 3.1009 2.90001 5.92592C2.90001 7.56575 3.67071 9.02874 4.86642 9.96752C2.46187 11.1403 0.8 13.6192 0.8 16.4815V16.734C0.8 16.9789 0.899788 17.2145 1.07585 17.3851L1.07598 17.3852C2.95225 19.1993 5.41131 20.2 8 20.2C10.5886 20.2 13.0476 19.1993 14.9238 17.3854C15.1003 17.2152 15.2 16.9794 15.2 16.734V16.4815C15.2 13.6192 13.5381 11.1403 11.1336 9.96755ZM4.70002 5.92592C4.70002 4.09517 6.18148 2.60741 8.00004 2.60741C9.8186 2.60741 11.3001 4.09517 11.3001 5.92592C11.3001 7.75667 9.8186 9.24444 8.00004 9.24444C6.18148 9.24444 4.70002 7.75667 4.70002 5.92592ZM8.00004 18.3926C6.00535 18.3926 4.10277 17.6671 2.60157 16.34C2.6766 13.4108 5.07047 11.0518 8.00004 11.0518C10.9296 11.0518 13.3235 13.4108 13.3985 16.34C11.8973 17.6671 9.99474 18.3926 8.00004 18.3926Z",
    fill: "#5C5C5C",
    stroke: "#5C5C5C",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.07da8abd.svg";
export { ForwardRef as ReactComponent };